export function isContentConfig(content) {
  return (content === null || content === void 0 ? void 0 : content.left) !== undefined;
}